var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solution-Submitted",
    clipPath: "url(#clip0_2855_117719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.645 15L1.7923 62.4372L49.2295 44.5845C35.2431 35.4644 28.798 28.9537 19.645 15ZM7.27909 56.3992C7.23944 57.0666 7.33164 57.7353 7.55042 58.367L12.3612 56.7011L17.172 55.0351C16.9533 54.4034 16.6122 53.8209 16.1683 53.3209C15.7244 52.821 15.1864 52.4134 14.585 52.1213C13.9836 51.8293 13.3305 51.6586 12.6631 51.6189C11.9957 51.5793 11.327 51.6715 10.6953 51.8903C10.0635 52.109 9.48103 52.4501 8.98108 52.894C8.48113 53.3379 8.0735 53.8759 7.78147 54.4773C7.48944 55.0787 7.31873 55.7318 7.27909 56.3992ZM12.0045 40.7139C12.8989 41.0236 13.8456 41.1541 14.7904 41.098C15.7353 41.0419 16.6598 40.8002 17.5112 40.3868C18.3627 39.9733 19.1244 39.3963 19.7528 38.6885C20.3812 37.9807 20.8641 37.156 21.1738 36.2616C21.4835 35.3672 21.614 34.4206 21.5579 33.4757C21.5018 32.5309 21.2601 31.6064 20.8467 30.7549C20.4332 29.9035 19.8562 29.1418 19.1484 28.5134C18.4406 27.885 17.6159 27.4021 16.7215 27.0924L14.363 33.9031L12.0045 40.7139ZM41.0529 44.607C41.4688 45.0656 41.7904 45.6016 41.9993 46.1845L37.5607 47.7747L33.1221 49.3649C32.9133 48.782 32.8213 48.1637 32.8514 47.5453C32.8815 46.9269 33.0332 46.3204 33.2977 45.7606C33.5622 45.2008 33.9343 44.6985 34.3929 44.2825C34.8515 43.8665 35.3876 43.5449 35.9705 43.3361C36.5534 43.1273 37.1717 43.0353 37.7901 43.0654C38.4085 43.0956 39.015 43.2472 39.5748 43.5117C40.1346 43.7762 40.6369 44.1484 41.0529 44.607ZM24.0303 46.1913C23.664 45.1689 22.5382 44.6371 21.5158 45.0034C20.4934 45.3696 19.9615 46.4954 20.3278 47.5178C20.6941 48.5402 21.8199 49.0721 22.8423 48.7058C23.8647 48.3395 24.3966 47.2138 24.0303 46.1913ZM27.3449 34.1268C29.0264 33.5244 30.8779 34.3992 31.4803 36.0807C32.0827 37.7622 31.208 39.6137 29.5265 40.2161C27.845 40.8185 25.9935 39.9438 25.391 38.2623C24.7886 36.5808 25.6634 34.7293 27.3449 34.1268Z",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3139 28.7843C45.8029 29.1712 42.6473 30.6972 40.8478 31.9701C40.2828 32.3696 39.4902 32.2503 39.0774 31.7035C38.6646 31.1567 38.7879 30.3896 39.3528 29.99C41.4351 28.5172 44.9983 26.7916 49.0272 26.3476C53.1036 25.8984 57.6933 26.7651 61.6002 30.5465C62.0949 31.0254 62.0949 31.8018 61.6002 32.2806C61.1054 32.7595 60.3033 32.7595 59.8085 32.2806C56.5487 29.1255 52.7774 28.4026 49.3139 28.7843Z",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3064 14.259C33.9066 17.6572 32.33 20.7114 31.015 22.4532C30.6021 23 30.7254 23.7672 31.2904 24.1667C31.8553 24.5663 32.6479 24.447 33.0607 23.9002C34.5824 21.8847 36.3652 18.436 36.8239 14.5364C37.2881 10.5909 36.3926 6.14859 32.4858 2.36719C31.991 1.88832 31.1889 1.88832 30.6941 2.36719C30.1993 2.84606 30.1993 3.62245 30.6941 4.10132C33.9539 7.25642 34.7008 10.9067 34.3064 14.259Z",
    fill: "#44484E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2593"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 1.24672,
    cy: 1.24672,
    r: 1.24672,
    transform: "matrix(0.71855 0.695476 -0.71855 0.695476 28.9025 15.3727)",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 92",
    cx: 1.24672,
    cy: 1.24672,
    r: 1.24672,
    transform: "matrix(0.71855 0.695476 -0.71855 0.695476 46.819 32.7139)",
    fill: "#44484E"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91",
    cx: 2.49344,
    cy: 2.49344,
    r: 2.49344,
    transform: "matrix(0.71855 0.695476 -0.71855 0.695476 46.3711 14.072)",
    fill: "#44484E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2855_117719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionFeed);
export default __webpack_public_path__ + "static/media/SolutionFeed.faad93a8aedea1d970ce1340586f4076.svg";
export { ForwardRef as ReactComponent };